export const PREVIOUSLY_ORDERED_SET_NAME = 'Previously Ordered'
export const DESIGN_PERSONALIZATIONS_SET_NAME = 'Email Campaign'
